/**
 * Utilidades de criptografía para el portal (convención vira-backend)
 */

/**
 * Genera el hash SHA256 de una cadena usando la Web Crypto API del navegador.
 * @param text Texto a hashear
 * @returns Promise con el hash SHA256 en hexadecimal
 */
export async function hashSHA256(text: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
}

/**
 * Encripta una contraseña con el mismo patrón del login:
 * 1. Primer nivel: SHA256(password)
 * 2. Segundo nivel: SHA256(primerHash + timestamp)
 *
 * @param password Contraseña en texto plano
 * @param timestamp Timestamp en milisegundos
 * @returns Hash que se envía al backend en el campo `password`
 */
export async function encryptPasswordWithTimestamp(
  password: string,
  timestamp: number
): Promise<string> {
  const levelOneEncryption = await hashSHA256(password);
  return hashSHA256(levelOneEncryption + timestamp);
}
